import { HOME_PHASE } from "@miplatform/constants";
import {
  getDate,
  isBefore,
  isDateAfter,
  isSameOrAfter,
} from "@miplatform/utils";

export const getHomePhase = (home) => {
  const today = getDate();
  const closingDate = home.closingDate ? getDate(home.closingDate) : null;
  const warrantyEndDate = home.warrantyEndDate
    ? getDate(home.warrantyEndDate)
    : null;

  if (!closingDate || isBefore(today, closingDate)) {
    return HOME_PHASE.UNDER_CONSTRUCTION;
  }
  if (
    warrantyEndDate &&
    isSameOrAfter(today, closingDate) &&
    isDateAfter(warrantyEndDate, today)
  ) {
    return HOME_PHASE.UNDER_WARRANTY;
  }
  if (!warrantyEndDate || isDateAfter(today, warrantyEndDate)) {
    return HOME_PHASE.OUT_OF_WARRANTY;
  }

  return HOME_PHASE.UNDER_CONSTRUCTION;
};
